import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/auth/services/authentication.service';

@Component({
  selector: 'app-list-warranties',
  templateUrl: './list-warranties.component.html',
  styleUrls: ['./list-warranties.component.scss']
})
export class ListWarrantiesComponent implements AfterViewInit {
  isUpdateOperation = false;
  constructor(public authService: AuthenticationService) {}

  ngAfterViewInit() {}
}
